export default __webpack_public_path__ + "static/media/landing-page-hero-image-mobile.feebbc9c.png";